import actionTypes from '@/redux/actions/bill/print/actionType';

const initialState: any = {
  // 基础信息
  orderInfoResponse: {},
  // 消费账目
  consumeBills: [],
  // 付款账目
  paymentBills: [],
  // 账目合计
  accountTotal: [],
  // 酒店基础信息
  hotelBasicInfoResp: {},
};

export default (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.TOGGLE_LOADING:
      const loading = state[action.payload];
      return {
        ...state,
        [action.payload]: !loading,
      };
    case actionTypes.UPDATE_STATE:
      return {
        ...state,
        ...action.payload,
      };
    case actionTypes.PRINT_INFO_LIST_LOADING:
      return {
        ...state,
        ...action.payload,
      };

    default:
      return {
        ...state,
        ...action.payload,
      };
  }
};
